module.exports = __webpack_public_path__ + "img/499.5e6b2985.jpg";